import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import { combineReducers } from 'redux';

import authReducer from './auth/reducer';
import configReducer from './config/reducer';
import userReducer from './user/reducer';
import organizationReducer from './organization/reducer';
import capabilitiesReducer from './capabilities/reducer';

const middlewares: any[] = [];

if (process.env.NODE_ENV === 'development') {
  middlewares.push(createLogger());
}

const rootReducer = combineReducers({
  auth: authReducer,
  config: configReducer,
  user: userReducer,
  organizations: organizationReducer,
  capabilities: capabilitiesReducer,
});

export const setupStore = (preloadedState?: Partial<RootState>) =>
  configureStore({
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [],
        },
      }).concat(...middlewares),
    devTools: process.env.NODE_ENV === 'development',
    reducer: rootReducer,
    preloadedState,
  });

export const store = setupStore();

if (process.env.NODE_ENV !== 'production' && module.hot) {
  module.hot.accept('./', () => store.replaceReducer(rootReducer));
}

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
